module.exports = __webpack_public_path__ + "cc2176a36232d5d7aea4a5f78f1e0f6b.MP3";